import { ConfirmDelete } from "../../../common/components/modal/confirmDelete/confirmDelete";

export const DeleteBillingModal = ({
  open,
  loading,
  onCancel,
  onDelete,
}) => (
  <ConfirmDelete
    open={open}
    onCancel={onCancel}
    onConfirm={onDelete}
    loading={loading}
  >
    Are you sure you want to delete this billing record?
  </ConfirmDelete>
);
